var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-btn",
        {
          staticClass: "social-share",
          attrs: { variant: "outline-secondary" },
          on: {
            click: function ($event) {
              _vm.modalShow = !_vm.modalShow
            },
          },
        },
        [
          _c("font-awesome-icon", {
            staticClass: "icon",
            attrs: { icon: _vm.getIcon("share") },
          }),
          _vm._v("\n    Share " + _vm._s(_vm.contentType) + "\n  "),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "AModal",
        {
          attrs: { title: `Share ${_vm.contentType} on Social Media` },
          model: {
            value: _vm.modalShow,
            callback: function ($$v) {
              _vm.modalShow = $$v
            },
            expression: "modalShow",
          },
        },
        [
          _c("div", { staticClass: "social-modal" }, [
            _c("div", { staticClass: "social-group branded" }, [
              _c(
                "ul",
                { staticClass: "social-list" },
                _vm._l(_vm.links, function (data, id) {
                  return _c(
                    "li",
                    { key: id, staticClass: "social-list-item" },
                    [
                      _c(
                        "a",
                        {
                          class: `social-link ${id}`,
                          attrs: {
                            href: data.url,
                            title: data.title,
                            target: "_blank",
                          },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "social-icon" },
                            [
                              _c("font-awesome-icon", {
                                staticClass: "icon",
                                attrs: { icon: _vm.getIcon(data.icon) },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("span", { staticClass: "text" }, [
                            _vm._v(
                              " " +
                                _vm._s(data.shareContext) +
                                " " +
                                _vm._s(data.title)
                            ),
                          ]),
                        ]
                      ),
                    ]
                  )
                }),
                0
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "pageurl-clipboard" },
              [
                _c(
                  "b-input-group",
                  [
                    _c("b-form-input", {
                      model: {
                        value: _vm.pageUrl,
                        callback: function ($$v) {
                          _vm.pageUrl = $$v
                        },
                        expression: "pageUrl",
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "b-input-group-append",
                      [
                        _c(
                          "b-btn",
                          {
                            directives: [
                              {
                                name: "clipboard",
                                rawName: "v-clipboard",
                                value: _vm.pageUrl,
                                expression: "pageUrl",
                              },
                            ],
                            attrs: {
                              variant: "outline",
                              type: "button",
                              title: "Copy to Clipboard",
                            },
                            on: {
                              success: function ($event) {
                                _vm.showSuccess = true
                              },
                            },
                          },
                          [
                            _c("font-awesome-icon", {
                              staticClass: "icon",
                              attrs: { icon: _vm.getIcon("copy") },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.showSuccess
                  ? _c(
                      "div",
                      { staticClass: "alert alert-success" },
                      [
                        _c("font-awesome-icon", {
                          staticClass: "icon",
                          attrs: { icon: _vm.getIcon("check") },
                        }),
                        _vm._v("\n          Copied!\n        "),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              1
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }